import { Col, Modal, Row } from 'antd'
import { Observer } from 'mobx-react-lite'
import React, { useRef } from 'react'

import IFrame from 'react-iframe'
import { createGlobalStyle } from 'styled-components'
import { useAppStore } from '../../store'
import { CloseOutlined } from '@ant-design/icons'
const GlobalStyle = createGlobalStyle`
  .Preview_IFrame {
    
    /* transform: translateY(-30px); */
  }
`

const OnlineDocPreviewModal = () => {
  const appStore = useAppStore()

  return (
    <Observer>
      {() => {
        const { isShowPreviewModal, previewUrl, closePreviewModal } = appStore

        return (
          <Modal
            visible={isShowPreviewModal}
            width="92%"
            centered
            bodyStyle={{ padding: 0, height: '92vh', overflow: 'hidden' }}
            footer={null}
            closable={false}
            destroyOnClose={true}
            onCancel={closePreviewModal}
            maskClosable={true}
          >
            <Row
              justify="end"
              style={{ position: 'relative', zIndex: 1, backgroundColor: '#FFFFFF', borderBottom: '1px #ccc solid' }}
            >
              <Col style={{ padding: '4px 8px' }}>
                <CloseOutlined onClick={closePreviewModal} />
              </Col>
            </Row>
            <GlobalStyle />
            <IFrame
              url={previewUrl}
              width="100%"
              height="100%"
              frameBorder={0}
              className="Preview_IFrame"
              loading={'auto'}
            />
          </Modal>
        )
      }}
    </Observer>
  )
}

export default OnlineDocPreviewModal
